import { WarningWingsIllustration } from '@carboncopyco/illustrations';
import { Button, Modal, Spacer, TextLargeParagraph } from '@carboncopyco/ui';
import type React from 'react';
import { useTourCapturePageProps } from './TourCapturePageContext';

interface FirstFrameFailedCapturingModalProps {
  anchorRef?: React.RefObject<HTMLElement>;
  open?: boolean;
  onConfirm?: () => void;
}

const FirstFrameFailedCapturingModal = ({
  anchorRef,
  open,
  onConfirm,
}: FirstFrameFailedCapturingModalProps) => {
  const { desktopHooks } = useTourCapturePageProps();
  desktopHooks?.useFocusModalAppService(open);

  return (
    <Modal
      open={open}
      anchorRef={anchorRef}
      onClose={() => undefined}
      removeCloseIcon
    >
      <div className="flex flex-col items-center w-ds-500 px-2 select-none">
        <div className="py-4">
          <WarningWingsIllustration />
        </div>
        <Spacer />
        <div className="w-ds-400 flex flex-auto text-center">
          <TextLargeParagraph
            label="Your first screen wasn't captured successfully.
            Please restart capturing."
            color="text-ds-natural-600"
          />
        </div>
        <Spacer amount={1.5} />
        <Button
          label="Restart capturing"
          onClick={onConfirm}
        />
      </div>
    </Modal>
  );
};

export default FirstFrameFailedCapturingModal;
